import { EXTERNAL_SCOPE_TYPES } from '../models/messaging-user';
import { MODEL_NAMES } from '../constants/index';
import Service, { service } from '@ember/service';

export default class ClientProfileNavigatorService extends Service {
  @service messaging;
  @service store;

  canNavigateToClientProfile(filteredUsers, isClinician) {
    const participantsAreClients = filteredUsers.every(
      user => user.externalScope === EXTERNAL_SCOPE_TYPES.client
    );

    return participantsAreClients && isClinician;
  }

  async navigateToClientProfile(conversation, filteredUsers) {
    const navigationData = await this.getNavigationDataFromConversation(
      conversation,
      filteredUsers
    );

    this.messaging.emitEvent('openClientProfile', navigationData);
  }

  async getNavigationDataFromConversation(conversation, filteredUsers) {
    // Handle Couple conversation case
    if (conversation.linkExternalId) {
      return {
        externalId: conversation.linkExternalId,
        isParentId: false,
      };
    }

    // Handle Contact vs Client conversation case
    const externalId = filteredUsers[0]?.externalId;
    const contact = await this.#fetchContact(externalId);

    return {
      externalId: contact?.parentExternalId || externalId,
      isParentId: !!contact?.parentExternalId,
    };
  }

  async #fetchContact(externalId) {
    // Check store cache first
    let contact = this.store
      .peekAll(MODEL_NAMES.CONTACT)
      .find(contact => contact.externalId === externalId);

    if (contact) {
      return contact;
    }

    // Fetch from API if not in cache
    const contacts = await this.store.query(MODEL_NAMES.CONTACT, {
      filter: { external_ids: externalId }, // eslint-disable-line camelcase
      include: 'couple',
      page: { number: 1, size: 1 },
    });

    return contacts.get('firstObject') || null;
  }
}
